import { type IconJVSProps, Segment } from '@mairistem/composants';
import _ from 'lodash';
import type React from 'react';

import Tile from './Tile';

export type TileItemType = {
  identifiant: number;
  titre: string | React.ReactNode;
  sousTitre?: string | React.ReactNode;
  iconName?: IconJVSProps['name'];
  [key: string]: unknown;
};

type TileListProps = {
  items: TileItemType[];
  onSelect?: (item: TileItemType) => void;
  selectedId?: number;
};

const TileList = ({ items, onSelect, selectedId }: TileListProps) => (
  <Segment.Group
    horizontal
    style={{
      padding: 10,
      margin: 0,
      border: 0,
      boxShadow: 'none',
      columnGap: 15,
      display: 'inline-flex',
      justifyContent: 'space-evenly',
      width: '100%',
      overflowX: 'auto',
    }}
  >
    {_.map(items, (item) => (
      <Tile
        selectable
        selected={selectedId === item.identifiant}
        header={item.titre}
        subheader={item.sousTitre}
        iconName={item.iconName}
        onClick={() => onSelect?.(item)}
      />
    ))}
  </Segment.Group>
);

export default TileList;
